
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"65","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_13028_43525)"}},[_c('path',{attrs:{"fill":"#fff","fill-opacity":".01","d":"M.5 0h64v40H.5z"}}),_c('path',{attrs:{"d":"M32.5 39.703c17.673 0 32-3.111 32-6.948 0-3.838-14.327-6.948-32-6.948-17.673 0-32 3.11-32 6.948 0 3.837 14.327 6.948 32 6.948z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M55.5 13.665L45.354 2.25C44.867 1.47 44.156 1 43.407 1H21.593c-.749 0-1.46.47-1.947 1.248L9.5 13.666v9.17h46v-9.17z","stroke":"#CED4DA"}}),_c('path',{attrs:{"d":"M42.113 16.813c0-1.593.994-2.909 2.227-2.91H55.5v18.003c0 2.107-1.32 3.834-2.95 3.834h-40.1c-1.63 0-2.95-1.728-2.95-3.834V13.903h11.16c1.233 0 2.227 1.313 2.227 2.907v.021c0 1.593 1.005 2.88 2.237 2.88h14.752c1.232 0 2.237-1.298 2.237-2.891v-.007z","fill":"#FAFAFA","stroke":"#CED4DA"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_13028_43525"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h64v40H0z"}})])])])
          )
        }
      }
    